var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team_7797136 1",
    clipPath: "url(#clip0_1449_12716)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "url(#paint0_linear_1449_12716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.8558 73.4312L46.8558 70.6563C47.2521 70.4363 47.4996 70.0175 47.4996 69.5625V65C47.4996 64.31 46.9408 63.75 46.2496 63.75C45.5583 63.75 44.9996 64.31 44.9996 65V68.8263L40.6433 71.245C40.0408 71.58 39.8221 72.3412 40.1571 72.945C40.6596 73.8162 41.6646 73.5375 41.8558 73.4312Z",
    fill: "url(#paint1_linear_1449_12716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.1437 59.0706L33.1437 61.8456C32.7475 62.0656 32.5 62.4843 32.5 62.9393V67.5018C32.5 68.1918 33.0587 68.7518 33.75 68.7518C34.4412 68.7518 35 68.1918 35 67.5018V63.6756L39.3563 61.2568C39.9588 60.9218 40.1775 60.1606 39.8425 59.5568C39.5075 58.9543 38.745 58.7368 38.1437 59.0706Z",
    fill: "url(#paint2_linear_1449_12716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M43.75 38.75C43.0588 38.75 42.5 39.31 42.5 40C42.5 41.3788 41.3787 42.5 40 42.5C38.6212 42.5 37.5 41.3788 37.5 40C37.5 39.31 36.9412 38.75 36.25 38.75C35.5588 38.75 35 39.31 35 40C35 42.7575 37.2425 45 40 45C42.7575 45 45 42.7575 45 40C45 39.31 44.4412 38.75 43.75 38.75Z",
    fill: "url(#paint3_linear_1449_12716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.5 20C21.1212 20 20 18.8788 20 17.5C20 16.81 19.4412 16.25 18.75 16.25C18.0588 16.25 17.5 16.81 17.5 17.5C17.5 20.2575 19.7425 22.5 22.5 22.5C23.1912 22.5 23.75 21.94 23.75 21.25C23.75 20.56 23.1912 20 22.5 20Z",
    fill: "url(#paint4_linear_1449_12716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M61.25 16.25C60.5588 16.25 60 16.81 60 17.5C60 18.8788 58.8788 20 57.5 20C56.8088 20 56.25 20.56 56.25 21.25C56.25 21.94 56.8088 22.5 57.5 22.5C60.2575 22.5 62.5 20.2575 62.5 17.5C62.5 16.81 61.9412 16.25 61.25 16.25Z",
    fill: "url(#paint5_linear_1449_12716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M65 25H64.0925C66.1762 23.1663 67.5 20.4875 67.5 17.5V10C67.5 4.48625 63.0137 0 57.5 0C54.8288 0 52.3175 1.04 50.4287 2.92875C48.54 4.8175 47.5 7.33 47.5 10V17.5C47.5 20.4875 48.8238 23.1663 50.9075 25H50C48.9475 25 47.9288 25.1362 46.9425 25.3475C45.8063 24.315 43.2388 22.5 40 22.5C37.3737 22.5 34.8775 23.5387 33.04 25.3438C32.0588 25.135 31.0462 25 30 25H29.0925C31.1763 23.1663 32.5 20.4875 32.5 17.5V10C32.5 7.32875 31.46 4.8175 29.5712 2.92875C27.6825 1.04 25.1712 0 22.5 0C16.9862 0 12.5 4.48625 12.5 10V17.5C12.5 20.4875 13.8237 23.1663 15.9075 25H15C6.72875 25 0 31.7288 0 40V50C0 54.1362 3.36375 57.5 7.5 57.5H18.3662C17.8037 59.0962 17.5 60.7912 17.5 62.5V72.5C17.5 76.6363 20.8638 80 25 80H55C59.1362 80 62.5 76.6363 62.5 72.5V62.5C62.5 60.7912 62.1962 59.0962 61.6338 57.5H72.5C76.6363 57.5 80 54.1362 80 50V40C80 31.7288 73.2712 25 65 25ZM52.1963 4.69625C53.6138 3.28 55.4975 2.5 57.5 2.5C61.6362 2.5 65 6.1275 65 10.2638L58.12 6.415C57.7362 6.195 57.2625 6.195 56.88 6.415L50 10.2638C50 8.26 50.78 6.11375 52.1963 4.69625ZM50 17.5V13.225L57.5 8.94L65 13.225V17.5C65 21.6362 61.6362 25 57.5 25C53.3638 25 50 21.6362 50 17.5ZM40 25C43.3838 25 45.5812 27.505 45.61 27.5375C46.8288 28.8888 47.5 30.91 47.5 32.7588L40.62 28.915C40.2362 28.695 39.7625 28.695 39.38 28.915L32.5 32.7588C32.5 30.91 33.1712 28.8888 34.4012 27.525C35.8075 25.9213 37.8475 25 40 25ZM40 47.5C35.8638 47.5 32.5 44.1362 32.5 40V35.725L40 31.44L47.5 35.725V40C47.5 44.1362 44.1362 47.5 40 47.5ZM22.5 2.5C24.5037 2.5 26.3862 3.28 27.8037 4.69625C29.22 6.1125 30 8.26 30 10.2638L23.12 6.415C22.7362 6.195 22.2625 6.195 21.88 6.415L15 10.2638C15 6.1275 18.3638 2.5 22.5 2.5ZM15 17.5V13.225L22.5 8.94L30 13.225V17.5C30 21.6362 26.6362 25 22.5 25C18.3638 25 15 21.6362 15 17.5ZM2.5 50V40C2.5 33.2938 7.81375 27.8187 14.45 27.5275L21.25 35.4613V41.25C21.25 41.94 21.8088 42.5 22.5 42.5C23.1912 42.5 23.75 41.94 23.75 41.25V35.4613L27.1988 31.4375C27.6488 30.9137 27.5887 30.1237 27.0637 29.675C26.5412 29.2275 25.7525 29.2875 25.3025 29.81L22.5012 33.0775L17.7188 27.4988H30.0012C30.4437 27.4988 30.875 27.5363 31.3037 27.5813C30.46 29.0625 30.0012 30.7513 30.0012 32.4987V39.9987C30.0012 42.9863 31.325 45.665 33.4087 47.4987H32.5013C29.235 47.4987 26.0913 48.5575 23.505 50.4987C22.0413 48.6262 19.8025 47.4987 17.3512 47.4987H14.2688L11.2513 44.4812V39.9987C11.2513 39.3088 10.6925 38.7487 10.0013 38.7487C9.31 38.7487 8.75125 39.3088 8.75125 39.9987V44.9987C8.75125 45.33 8.8825 45.6488 9.1175 45.8825L12.5013 49.2662V54.9987H7.5C4.7425 54.9987 2.5 52.7575 2.5 50ZM19.5225 55H15V50H17.35C19.075 50 20.6488 50.815 21.64 52.1637C20.8213 53.02 20.115 53.97 19.5225 55ZM30 74.6237L35.1763 77.5H30V74.6237ZM50 77.5H44.8238L50 74.6237V77.5ZM50 71.765L40 77.32L30 71.765V60.7363L40 55.1813L50 60.7363V71.765ZM60 72.5C60 75.2575 57.7575 77.5 55 77.5H52.5V73.0175L55.8838 69.6338C56.3725 69.145 56.3725 68.355 55.8838 67.8662C55.395 67.3775 54.605 67.3775 54.1162 67.8662L52.5 69.4825V60C52.5 59.5462 52.2537 59.1275 51.8563 58.9075L40.6063 52.6575C40.23 52.4475 39.7687 52.4475 39.3925 52.6575L28.1425 58.9075C27.7463 59.1275 27.4988 59.5462 27.4988 60V69.4825L25.8825 67.8662C25.3937 67.3775 24.6038 67.3775 24.115 67.8662C23.6262 68.355 23.6262 69.145 24.115 69.6338L27.4988 73.0175V77.5H24.9988C22.2413 77.5 19.9987 75.2575 19.9987 72.5V62.5C19.9987 60.4912 20.4562 58.5812 21.3638 56.8162C22.0462 55.4737 22.9538 54.2825 24.0675 53.2725C26.3787 51.1625 29.3725 50 32.4987 50H47.4987C50.625 50 53.6188 51.1625 55.9338 53.2762C57.0438 54.2837 57.9513 55.4737 58.6338 56.8175L58.6362 56.8225C59.5413 58.5825 59.9987 60.4925 59.9987 62.5013V72.5013L60 72.5ZM65 55H60.4775C59.8838 53.97 59.1775 53.0187 58.36 52.1637C59.3512 50.8137 60.925 50 62.65 50H65V55ZM77.5 50C77.5 52.7575 75.2575 55 72.5 55H67.5V49.2675L70.8838 45.8838C71.1188 45.6488 71.25 45.3312 71.25 45V40C71.25 39.31 70.6913 38.75 70 38.75C69.3087 38.75 68.75 39.31 68.75 40V44.4825L65.7325 47.5H62.65C60.1987 47.5 57.96 48.6288 56.4962 50.5C53.9075 48.5575 50.765 47.5 47.5 47.5H46.5925C48.6762 45.6662 50 42.9875 50 40V32.5C50 30.7525 49.5413 29.065 48.6975 27.5825C49.1263 27.5375 49.5575 27.5 50 27.5H62.2825L57.5 33.0788L54.6987 29.8113C54.2512 29.2888 53.4625 29.2275 52.9375 29.6762C52.4125 30.125 52.3512 30.915 52.8025 31.4387L56.2513 35.4625V41.2513C56.2513 41.9412 56.81 42.5013 57.5013 42.5013C58.1925 42.5013 58.7513 41.9412 58.7513 41.2513V35.4625L65.5513 27.5288C72.1875 27.82 77.5013 33.2938 77.5013 40.0013V50.0013L77.5 50Z",
    fill: "url(#paint6_linear_1449_12716)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1449_12716",
    x1: 16.8421,
    y1: 20.5263,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1449_12716",
    x1: 8.07,
    y1: 7.03508,
    x2: 62.6985,
    y2: 101.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58156,
    stopColor: "#E2DB34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80156,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1449_12716",
    x1: 0.569995,
    y1: 2.03308,
    x2: 55.4387,
    y2: 97.0693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58156,
    stopColor: "#E2DB34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80156,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1449_12716",
    x1: -7.57581,
    y1: 2.6131,
    x2: 13.0109,
    y2: 77.4528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58156,
    stopColor: "#E2DB34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80156,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1449_12716",
    x1: -9.10988,
    y1: -19.8869,
    x2: 20.5717,
    y2: 47.5521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58156,
    stopColor: "#E2DB34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80156,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1449_12716",
    x1: 29.6401,
    y1: -19.8869,
    x2: 59.3217,
    y2: 47.5521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58156,
    stopColor: "#E2DB34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80156,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1449_12716",
    x1: 14.1263,
    y1: -4.325,
    x2: 64.9487,
    y2: 83.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#E2D134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#CE5B5B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1449_12716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.16209890ae6f3f996cdc1e5b12e59d62.svg";
export { ForwardRef as ReactComponent };